export default __webpack_public_path__ + "static/cats-d2d9b6816f2a3104f3392031ae7ef94f.jpg";